
import store from './store'

const items = []

// user permission
if (store.getters.permission >= 1) {
  items.push(
    {
      name: 'AdGenerator',
      url: '/dashboard',
      icon: 'icon-speedometer',
      badge: {
        variant: 'primary',
        text: ''
      }
    },
    {
      name: 'Deployments',
      url: '/deploy/history',
      icon: 'icon-list'
    },
    {
      title: true,
      name: 'Banners',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Manage',
      url: '/banners/manage',
      icon: 'icon-list'
    }
  )
}

//  editor permission ( + user permission )
if (store.getters.permission >= 2) {
  items.push(
    {
      name: 'Create',
      url: '/banners/create',
      icon: 'icon-pencil'
    }
  )
}

if (store.state.permission >= 3) {
  items.push(
    {
      name: 'Replace Banner HTML',
      url: '/banners/replace',
      icon: 'icon-list'
    }
  )
}

if (store.getters.permission >= 2) {
  items.push(
    {
      title: true,
      name: 'Bookmakers',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Manage',
      url: '/bookmakers',
      icon: 'icon-list'
    },
    {
      title: true,
      name: 'Templates',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Manage',
      url: '/templates',
      icon: 'icon-list'
    },
    {
      title: true,
      name: 'Affiliates',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Manage',
      url: '/affiliates',
      icon: 'icon-list'
    },
    {
      title: true,
      name: 'Campaigns',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Manage',
      url: '/campaigns',
      icon: 'icon-list'
    },
    {
      title: true,
      name: 'Matches',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Manage',
      url: '/matches/manage',
      icon: 'icon-list'
    },
    {
      name: 'Create',
      url: '/matches/create',
      icon: 'icon-pencil'
    },
    {
      title: true,
      name: 'Statistics',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Slugs',
      url: '/slugs',
      icon: 'icon-list'
    }
  )
}

// admin permission ( + editor permission )
if (store.getters.permission >= 2) {
  items.push(

    {
      name: 'Affiliate Codes',
      url: '/affcodes',
      icon: 'icon-list'
    },
    {
      name: 'Referrers',
      url: '/referrers',
      icon: 'icon-list'
    },
    {
      title: true,
      name: 'CSS',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Manage',
      url: '/css/manage',
      icon: 'icon-list'
    },
    {
      name: 'Upload',
      url: '/css/upload',
      icon: 'icon-pencil'
    },
    {
      name: 'Create',
      url: '/css/create',
      icon: 'icon-edit'
    }
  )
}

export default {
  items
}
